import { ApiComponentType, ApiRentalCar } from '@ibe/api';
import dayjs from 'dayjs';
import { useTheme } from '@emotion/react';
import React, { JSX } from 'react';
import { ComponentBoxProps } from '../../../Models/ItemRegistry';
import PackageBox from '../../Components/PackageBox/PackageBox';
import PackageBoxServiceInfoLayout from '../../Components/PackageBox/PackageBoxServiceInfoLayout';
import default404Image from '../../Components/UI/Images/Default404Image';
import { Slider } from '../../Components/UI/Slider/Slider';
import { configService } from '../../Hooks/Contexts';
import Keys from '../../../_Translations/generated/customizer.en.t.json.keys';
import fallback from '../../../_Translations/generated/customizer.en.t.json';
import useTranslation from '../../Hooks/useTranslation';

const config = configService.get();

const PackageComponentBox = (props: ComponentBoxProps): JSX.Element => {
  const { component, onRemoveComponent } = props;
  const { t } = useTranslation('customizer', fallback, Keys);
  const service = component.selectedItems[0] as ApiRentalCar;

  const theme = useTheme();
  const imageCarUrl = service.externalImgUrl
    ? service.externalImgUrl.small.url
    : theme.placeholderImages.rentalCar;

  const pickupDate = dayjs(service.pickupDate).format(config.formatDate);
  const dropoffDate = dayjs(service.dropoffDate).format(config.formatDate);

  return (
    <PackageBox
      header={<Slider images={[imageCarUrl]} placeholderImage={default404Image} mobileControls />}
      onRemoveComponent={(): void =>
        onRemoveComponent && onRemoveComponent(component.id, service.id)
      }
      content={
        <PackageBoxServiceInfoLayout
          headline={service.name}
          unitDescription={[
            service.pickupStation?.description,
            service.dropoffStation?.description
          ].join(' - ')}
          pickUpDate={pickupDate}
          pickUpTime={service.pickupTime}
          dropOffDate={dropoffDate}
          dropOffTime={service.dropoffTime}
          changeServiceLabel={t(Keys.serviceLabelRentalCar)}
        />
      }
      isIncluded={component.componentType !== ApiComponentType.OPTIONAL}
    />
  );
};

export default PackageComponentBox;
